import React from "react";
import styles from "../styles/NotFoundPage.module.css";
import cx from "classnames";
import Link from "next/link";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI

    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    // You can use your own error logging service here

    console.log(String(error));
  }
  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div
          className={cx(
            styles.container,
            "w-100",
            "d-flex",
            "flex-column",
            "align-items-center",
            "justify-content-center"
          )}
        >
          <div className="d-none d-lg-flex align-items-center justify-content-center">
            <svg
              width="115"
              height="171"
              viewBox="0 0 115 171"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1392_3271)">
                <path
                  d="M98.34 7.5V40.08C98.34 43.95 95.18 47.08 91.32 47.08H88.02L76.99 55.41V47.08H74.52C70.65 47.08 67.5 43.95 67.5 40.08V7.5C67.5 3.63 70.66 0.5 74.52 0.5H91.33C95.2 0.5 98.35 3.63 98.35 7.5H98.34Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19.5395 89.0801H96.0395C105.99 89.0801 114.07 97.1601 114.07 107.11V170.13H1.51953V107.11C1.51953 97.1601 9.59953 89.0801 19.5495 89.0801H19.5395Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M88.8086 130.881H98.2186C99.8086 130.881 101.099 132.171 101.099 133.761C101.099 135.351 99.8086 136.641 98.2186 136.641H88.8086V130.891V130.881Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M88.8086 136.631H101.189C102.779 136.631 104.069 137.921 104.069 139.511C104.069 141.101 102.779 142.391 101.189 142.391H88.8086V136.641V136.631Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M88.8086 142.381H101.189C102.779 142.381 104.069 143.671 104.069 145.261C104.069 146.851 102.779 148.141 101.189 148.141H88.8086V142.391V142.381Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M88.8086 148.131H98.3486C99.9386 148.131 101.229 149.421 101.229 151.011C101.229 152.601 99.9386 153.891 98.3486 153.891H88.8086V148.141V148.131Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M88.81 130.881H1.5V153.881H88.81V130.881Z"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17.2383 138.14L24.4983 130.88V89.0801H19.5183C9.55828 89.0801 1.48828 97.1501 1.48828 107.11V153.88H24.4883"
                  fill="white"
                />
                <path
                  d="M17.2383 138.14L24.4983 130.88V89.0801H19.5183C9.55828 89.0801 1.48828 97.1501 1.48828 107.11V153.88H24.4883"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M26.7617 125.119H17.3517C15.7617 125.119 14.4717 123.829 14.4717 122.239C14.4717 120.649 15.7617 119.359 17.3517 119.359H26.7617V125.109V125.119Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M26.7617 130.869H14.3817C12.7917 130.869 11.5017 129.579 11.5017 127.989C11.5017 126.399 12.7917 125.109 14.3817 125.109H26.7617V130.859V130.869Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M26.7617 136.619H14.3817C12.7917 136.619 11.5017 135.329 11.5017 133.739C11.5017 132.149 12.7917 130.859 14.3817 130.859H26.7617V136.609V136.619Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M26.7617 142.379H17.2217C15.6317 142.379 14.3417 141.089 14.3417 139.499C14.3417 137.909 15.6317 136.619 17.2217 136.619H26.7617V142.369V142.379Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M114.072 119.379H26.7617V142.379H114.072V119.379Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M98.3186 126.64L91.0586 119.38V89.0898H96.0386C105.999 89.0898 114.069 97.1599 114.069 107.12V142.39H91.0686"
                  fill="white"
                />
                <path
                  d="M98.3186 126.64L91.0586 119.38V89.0898H96.0386C105.999 89.0898 114.069 97.1599 114.069 107.12V142.39H91.0686"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M44.6602 65.2305C45.3102 66.5105 46.1402 67.6805 47.1302 68.6705H44.6602V65.2305Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M70.9102 77.2598H44.6602V89.0798H70.9102V77.2598Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M50.3302 54.0996H65.2402C68.3702 54.0996 70.9102 56.6396 70.9102 59.7696V78.7496C70.9102 80.6196 69.4002 82.1296 67.5302 82.1296H48.0402C46.1702 82.1296 44.6602 80.6196 44.6602 78.7496V59.7696C44.6602 56.6396 47.2002 54.0996 50.3302 54.0996Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M70.9219 64.7695H72.2019C72.6319 64.7695 72.9719 65.1195 72.9719 65.5395V69.3995C72.9719 69.8295 72.6219 70.1695 72.2019 70.1695H70.9219V64.7695Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M44.6719 70.1602H43.3919C42.9619 70.1602 42.6219 69.8102 42.6219 69.3902V65.5302C42.6219 65.1002 42.9719 64.7602 43.3919 64.7602H44.6719V70.1602Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M64.8203 77.2487C63.4203 74.8387 60.8103 73.2188 57.8203 73.2188C54.8303 73.2188 52.2203 74.8387 50.8203 77.2487"
                  fill="white"
                />
                <path
                  d="M64.8203 77.2487C63.4203 74.8387 60.8103 73.2188 57.8203 73.2188C54.8303 73.2188 52.2203 74.8387 50.8203 77.2487"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M85.7497 30.4904H80.9297L79.9297 10.4004H86.7497L85.7497 30.4904Z"
                  fill="#1F3AE1"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M83.3389 40.1505C84.9737 40.1505 86.2989 38.8252 86.2989 37.1905C86.2989 35.5557 84.9737 34.2305 83.3389 34.2305C81.7041 34.2305 80.3789 35.5557 80.3789 37.1905C80.3789 38.8252 81.7041 40.1505 83.3389 40.1505Z"
                  fill="#1F3AE1"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_1392_3271">
                  <rect width="115" height="171" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="d-lg-none d-flex align-items-center justify-content-center">
            <svg
              width="115"
              height="171"
              viewBox="0 0 115 171"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1734_8732)">
                <path
                  d="M98.34 7.5V40.08C98.34 43.95 95.18 47.08 91.32 47.08H88.02L76.99 55.41V47.08H74.52C70.65 47.08 67.5 43.95 67.5 40.08V7.5C67.5 3.63 70.66 0.5 74.52 0.5H91.33C95.2 0.5 98.35 3.63 98.35 7.5H98.34Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19.5395 89.0801H96.0395C105.99 89.0801 114.07 97.1601 114.07 107.11V170.13H1.51953V107.11C1.51953 97.1601 9.59953 89.0801 19.5495 89.0801H19.5395Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M88.8086 130.881H98.2186C99.8086 130.881 101.099 132.171 101.099 133.761C101.099 135.351 99.8086 136.641 98.2186 136.641H88.8086V130.891V130.881Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M88.8086 136.631H101.189C102.779 136.631 104.069 137.921 104.069 139.511C104.069 141.101 102.779 142.391 101.189 142.391H88.8086V136.641V136.631Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M88.8086 142.381H101.189C102.779 142.381 104.069 143.671 104.069 145.261C104.069 146.851 102.779 148.141 101.189 148.141H88.8086V142.391V142.381Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M88.8086 148.131H98.3486C99.9386 148.131 101.229 149.421 101.229 151.011C101.229 152.601 99.9386 153.891 98.3486 153.891H88.8086V148.141V148.131Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M88.81 130.881H1.5V153.881H88.81V130.881Z"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17.2383 138.14L24.4983 130.88V89.0801H19.5183C9.55828 89.0801 1.48828 97.1501 1.48828 107.11V153.88H24.4883"
                  fill="white"
                />
                <path
                  d="M17.2383 138.14L24.4983 130.88V89.0801H19.5183C9.55828 89.0801 1.48828 97.1501 1.48828 107.11V153.88H24.4883"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M26.7617 125.119H17.3517C15.7617 125.119 14.4717 123.829 14.4717 122.239C14.4717 120.649 15.7617 119.359 17.3517 119.359H26.7617V125.109V125.119Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M26.7617 130.869H14.3817C12.7917 130.869 11.5017 129.579 11.5017 127.989C11.5017 126.399 12.7917 125.109 14.3817 125.109H26.7617V130.859V130.869Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M26.7617 136.619H14.3817C12.7917 136.619 11.5017 135.329 11.5017 133.739C11.5017 132.149 12.7917 130.859 14.3817 130.859H26.7617V136.609V136.619Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M26.7617 142.379H17.2217C15.6317 142.379 14.3417 141.089 14.3417 139.499C14.3417 137.909 15.6317 136.619 17.2217 136.619H26.7617V142.369V142.379Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M114.072 119.379H26.7617V142.379H114.072V119.379Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M98.3186 126.64L91.0586 119.38V89.0898H96.0386C105.999 89.0898 114.069 97.1599 114.069 107.12V142.39H91.0686"
                  fill="white"
                />
                <path
                  d="M98.3186 126.64L91.0586 119.38V89.0898H96.0386C105.999 89.0898 114.069 97.1599 114.069 107.12V142.39H91.0686"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M44.6602 65.2305C45.3102 66.5105 46.1402 67.6805 47.1302 68.6705H44.6602V65.2305Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M70.9102 77.2598H44.6602V89.0798H70.9102V77.2598Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M50.3302 54.0996H65.2402C68.3702 54.0996 70.9102 56.6396 70.9102 59.7696V78.7496C70.9102 80.6196 69.4002 82.1296 67.5302 82.1296H48.0402C46.1702 82.1296 44.6602 80.6196 44.6602 78.7496V59.7696C44.6602 56.6396 47.2002 54.0996 50.3302 54.0996Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M70.9219 64.7695H72.2019C72.6319 64.7695 72.9719 65.1195 72.9719 65.5395V69.3995C72.9719 69.8295 72.6219 70.1695 72.2019 70.1695H70.9219V64.7695Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M44.6719 70.1602H43.3919C42.9619 70.1602 42.6219 69.8102 42.6219 69.3902V65.5302C42.6219 65.1002 42.9719 64.7602 43.3919 64.7602H44.6719V70.1602Z"
                  fill="white"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M64.8203 77.2487C63.4203 74.8387 60.8103 73.2188 57.8203 73.2188C54.8303 73.2188 52.2203 74.8387 50.8203 77.2487"
                  fill="white"
                />
                <path
                  d="M64.8203 77.2487C63.4203 74.8387 60.8103 73.2188 57.8203 73.2188C54.8303 73.2188 52.2203 74.8387 50.8203 77.2487"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M85.7497 30.4904H80.9297L79.9297 10.4004H86.7497L85.7497 30.4904Z"
                  fill="#1F3AE1"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M83.3389 40.1505C84.9737 40.1505 86.2989 38.8252 86.2989 37.1905C86.2989 35.5557 84.9737 34.2305 83.3389 34.2305C81.7041 34.2305 80.3789 35.5557 80.3789 37.1905C80.3789 38.8252 81.7041 40.1505 83.3389 40.1505Z"
                  fill="#1F3AE1"
                  stroke="#3D3D3C"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_1734_8732">
                  <rect width="115" height="171" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <h1 className={cx(styles.pageTitle)}>
            خطایی در بارگذاری صفحه رخ داده است.
          </h1>
          <Link
            href="/"
            className={cx(
              styles.btnStyles,
              "d-flex",
              "align-items-center",
              "justify-content-center"
            )}
          >
            بازگشت به صفحه اصلی
          </Link>
        </div>
      );
    }

    // Return children components in case of no error

    return this.props.children;
  }
}

export default ErrorBoundary;
